import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "PrecisionRecipeStepList": () => import("./components/common/PrecisionRecipeStepList.vue"),
    "PrecisionStepsDateAdjuster": () => import("./components/common/PrecisionStepsDateAdjuster.vue"),
    "PrecisionRecipeBuilderContainer": () => import("./components/PrecisionRecipeBuilderContainer.vue"),
    "PrecisionStepBuilder": () => import("./components/common/PrecisionStepBuilder.vue"),
    "PrecisionRecipeBuilder": () => import("./components/common/PrecisionRecipeBuilder.vue"),
    "PrecisionRecipeTile": () => import("./components/tiles/PrecisionRecipeTile.vue"),
    "PrecisionMapTile": () => import("./components/tiles/PrecisionMapTile.vue"),
    "PrecisionApplyRecipeTile": () => import("./components/tiles/PrecisionApplyRecipeTile.vue"),
    "StatsSaver": () => import("./components/common/StatsSaver.vue"),
    "CustomStepForm": () => import("./components/builders/CustomStepForm.vue"),
    "MeteoStepForm": () => import("./components/builders/MeteoStepForm.vue"),
    "PixelStepForm": () => import("./components/builders/PixelStepForm.vue"),
    "RasterStepForm": () => import("./components/builders/RasterStepForm.vue"),
    "ExternalAlgorithmStepForm": () => import("./components/builders/ExternalAlgorithmStepForm.vue"),
    "PrecisionStatisticsHistory": () => import("./components/common/PrecisionStatisticsHistory.vue")
};

export default globals;
